import { FC } from 'react';
import { Backdrop, Modal, Slide } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ReviewCard from './Card';
import './styles.scss';

const reviewsFirst = [
  {
    user: 'Our Private Driver - Sept 2024',
    description: 'Excellent company to work with! Robert our host was very helpful.',
    image: 'images/van-review-1.jpg',
    title: '15 Seater Mercedes-Benz Sprinter'
  },
  {
    user: 'Georges A. - Aug 2024',
    description: 'Great van rental experience. 5 star service',
    image: 'images/van-review-2.jpg',
    title: '15 Seater Mercedes-Benz Sprinter'
  },
  {
    user: 'Jackson D. - Aug 2024',
    description:
      'Robert was great! He made the whole process very easy and was very accommodating on short notice.',
    image: 'images/van-review-2.jpg',
    title: '15 Seater Mercedes-Benz Sprinter'
  },
  {
    user: 'Angelica D. - Aug 2024',
    description:
      'We rented the 15-seater van from Robert. Robert’s very responsive and accommodating. There was some mal-function with the first van. Might be some loose wires. Robert made sure we were safe and had a peace of mind. Robert drove all the way from San Diego to where we were (Victorville, CA) to switch the vans with a full tank of gas! No issues after that! We paid extra to get it drop off/pick up, worth it! It was a very fun trip! Will rent from Robert again!',
    image: 'images/van-review-4.jpg',
    title: '15 Seater Mercedes-Benz Sprinter'
  },
  {
    user: 'Francisco E. - Aug 2024',
    description:
      'Robert was great and concern about us. Hope he solved AC problems in both sprinters. Glad to make deals in future.',
    image: 'images/van-review-3.jpg',
    title: '15 Seater Ford Tansit Van'
  }
];

const reviewsSec = [
  {
    user: 'David R. - Aug 2024',
    description:
      'We hired Mercedes Sprinter for our family holiday around America, it was great 👍. Thanks to Robert and his team we had a great trip and we all travelled together. Highly recommended Sprinter Rentals …',
    image: 'images/van-review-4.jpg',
    title: '15 Seater Mercedes-Benz Sprinter'
  },
  {
    user: 'Donald H. - Aug 2024',
    description:
      'Van was in decent shape besides the faulty gas gauge and DEF alert. Could of been a little cleaner but quick communication from Robert throughout rental process. Efficient forms and rental process besides the east economy pickup and drop off. Would rent from Sprinter Rentals again.',
    image: 'images/van-review-1.jpg',
    title: '15 Seater Mercedes-Benz Sprinter'
  },
  {
    user: 'Toby - June 2024',
    description: 'No Comment 😊, our photo says it all.',
    image: 'images/van-review-5.jpg',
    title: '15 Seater Mercedes-Benz Sprinter'
  },
  {
    user: 'CFD - ESL - Aug 2024',
    description:
      'My group of 14 was on a Las Vegas - Los Angeles adventure camp; and we decided to rent the 15-passenger van to have a more personal tour. And this went above and beyond what we expected. First and foremost, the van was so spacious and drove so smoothly; and we also received VIP treatment at hotels and restaurants for its sleek look! Secondly, I had some doubts about the virtual rental and communication; but Michael, David, and the team provided clear instructions and responses to any questions; which made the whole process much more convenient than at any rental office I had used before. Thanks so much guys. Some other bonus points; excellent views from windows but private; very good on fuel; excellent navigation system. Overall, I strongly recommend this service for your own personal holiday adventure. Kudos to the team and I hope to rent again from you soon! -Julio and his Korean group!',
    image: 'images/van-review-6.jpg',
    title: '12 Seater Mercedes-Benz Sprinter'
  }
];

interface IProps {
  open: boolean;
  handleClose: () => void;
}

const ReviewModal: FC<IProps> = ({ open, handleClose }) => {
  return (
    <Modal open={open} onClose={handleClose} BackdropComponent={Backdrop} closeAfterTransition>
      <Slide direction='right' in={open} mountOnEnter unmountOnExit>
        <div className='right-float-modal modal'>
          <div className='review-modal'>
            <div className='vanModal__top-panel'>
              <ArrowBackIosIcon onClick={handleClose} />
              <div className='vanModal__top-panel__container'>
                <a href='https://www.sprinter-rentals.com/reviews' target='_blank'>
                  Open in a new window
                  <OpenInNewIcon />
                </a>
              </div>
            </div>
            <div className='review-modal__container'>
              <div className='review-modal__column'>
                {reviewsFirst.map((el, key) => (
                  <ReviewCard
                    user={el.user}
                    description={el.description}
                    image={el.image}
                    title={el.title}
                    key={key}
                  />
                ))}
              </div>
              <div className='review-modal__column'>
                {reviewsSec.map((el, key) => (
                  <ReviewCard
                    user={el.user}
                    description={el.description}
                    image={el.image}
                    title={el.title}
                    key={key}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </Slide>
    </Modal>
  );
};
export default ReviewModal;
